import { useEffect, useState } from "react";
import { Alert, Button, Card, Image, Table } from "antd";
import type { ColumnsType } from "antd/es/table";
import { listShopOrderRemarks } from "@/api/shopOrder";
import type { ShopOrderRemark } from "@/api/shopOrder";
import { formatDateTime } from "@/utils/dateTime";

const columns: ColumnsType<ShopOrderRemark> = [
  { title: "备注内容", dataIndex: "remarkContent", render: (value: string): React.ReactNode =>
    <div style={{ whiteSpace: "pre-wrap", overflowWrap: "anywhere" }}>{value}</div> },
  { title: "图片", width: 100, render: (_: unknown, row: ShopOrderRemark): React.ReactNode =>
    row.image ? <Image width={64} src={row.image} alt="备注图片" /> : "-" },
  { title: "创建人", dataIndex: "createBy", width: 130 },
  { title: "创建时间", dataIndex: "createTime", width: 170, render: formatDateTime },
];
export function OrderRemarks({ orderId }: { orderId: number | string }): React.ReactElement {
  const [remarks, setRemarks] = useState<ShopOrderRemark[]>([]);
  const [loading, setLoading] = useState(true);
  const [failed, setFailed] = useState(false);
  const [revision, setRevision] = useState(0);
  useEffect(() => {
    const controller = new AbortController();
    setLoading(true); setFailed(false); setRemarks([]);
    void listShopOrderRemarks(orderId, controller.signal).then(({ data }) => {
      if (!controller.signal.aborted) setRemarks([...(data ?? [])].sort((a, b) =>
        (b.createTime ?? "").localeCompare(a.createTime ?? "")));
    }).catch(() => {
      if (!controller.signal.aborted) setFailed(true);
    }).finally(() => {
      if (!controller.signal.aborted) setLoading(false);
    });
    return (): void => controller.abort();
  }, [orderId, revision]);
  const handleRetry = (): void => setRevision((value) => value + 1);
  return <Card title="订单备注">
    {failed ? <Alert type="error" message="订单备注加载失败" action={<Button onClick={handleRetry}>重试</Button>} /> :
      <Table<ShopOrderRemark> rowKey="id" columns={columns} dataSource={remarks} loading={loading}
        size="small" pagination={false} locale={{ emptyText: "暂无订单备注" }} />}
  </Card>;
}
